class Tabs {
    constructor() {
        let _this = this;

        this.checkTabNav();

        $(document).on('click', '.tabs__button', function (e) {
            e.preventDefault();
            if (
                $(this).children('a').length &&
                $(this).children('a')[0].hasAttribute('href')
            ) {
                return (window.location = $(this).children('a').attr('href'));
            }
            let $parent = $(this).closest('.tabs');
            let $targetTab = $parent.find('.tabs__item').eq($(this).index());
            $(this)
                .addClass('active')
                .siblings('.tabs__button')
                .removeClass('active');
            $targetTab
                .addClass('active')
                .siblings('.tabs__item')
                .removeClass('active')
                .removeAttr('style');
            _this.placeUnderline($(this).closest('.tabs-nav'));
        });

        $(window).on('resize', function () {
            return _this.checkTabNav();
        });

        $('.tabs').addClass('tabs-on');
    }

    checkTabNav() {
        let _this = this;
        $('.tabs-nav').each(function () {
            let children = $(this).children();
            let childrenWidth = _this.calcChildrenWidth(children);
            if ($(window).innerWidth() < childrenWidth + 40) {
                $(this).closest('.tabs').addClass('m-tabs');
            } else {
                $(this).closest('.tabs').removeClass('m-tabs');
            }

            _this.placeUnderline($(this));
        });
    }

    calcChildrenWidth($collection) {
        let res = 0;
        $collection.each(function (index, el) {
            res += $(el).outerWidth();
        });
        return res;
    }

    placeUnderline(nav) {
        let active = nav.find('.active');
        let underline = nav.closest('.tabs-head').find('.tabs-nav-active-rect');

        if (!underline.length) return;

        underline.removeClass('to-left to-right');

        if (underline.offset().left < active.offset().left) {
            underline.addClass('to-right');
        } else {
            underline.addClass('to-left');
        }

        underline.css({
            left: active.offset().left,
            right:
                $(window).innerWidth() -
                (active.offset().left + active.outerWidth()),
        });
    }
}

export default new Tabs();
